import React, { Component } from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import FirebaseActionCnn from '../Auth/connected/FirebaseActionCnn';

type Props = RouteComponentProps<any>

class FirebaseActionView extends Component<Props> {
    render() {
        return (
            <div>
                <FirebaseActionCnn />
            </div>
        );
    }
}

export default withRouter(FirebaseActionView);